export default{

    EDIT_STATUS_SCHEDULE: (state, status) => {
        state.statusSchedule = status
    }
}